import get from 'lodash/get'
import reduce from 'lodash/reduce'

export const UNHANDLED_ERROR = 'Unhandled Error'
export const WRONG = 'Something went wrong'

export const getErrors = (error) => get(error, 'response.body.errors', [])

export const getFirstError = (error) => get(error, 'response.body.errors[0]', {})

export const getFirstPreformedError = (error) => {
  const err = getFirstError(error)

  return {
    title: err.title || WRONG,
    message: err.message || err.detail || UNHANDLED_ERROR,
    status: err.status || err.statusCode || 500,
  }
}

const processMessage = (message) => {
  const brooklynErrorSeparator = 'NR-LINKING'
  const processedMessage = message
    .split(brooklynErrorSeparator)[0]
    .replace(/_/g, ' ')

  return processedMessage
}

export const getFirstErrorMessage = (error, messagePrefix = '') => {
  const err = getFirstError(error)
  const message = err.message || err.detail || UNHANDLED_ERROR
  const meta = reduce(err.meta, (acc, item) => `${acc} ${item}`, '')

  return `${messagePrefix}${processMessage(message)} ${meta}`
}
